// Frontend error reporting. Posts uncaught errors and unhandled promise
// rejections to /api/errlog (vfco-errlog backend endpoint). Sampling
// caps to keep cost predictable.

const ENDPOINT = '/api/errlog';
const MAX_PER_MINUTE = 30;
let bucket = MAX_PER_MINUTE;
setInterval(() => (bucket = MAX_PER_MINUTE), 60_000);

type ErrPayload = {
  message: string;
  stack?: string;
  url: string;
  ua: string;
  ts: string;
  context?: Record<string, unknown>;
};

export function initErrlog(): void {
  window.addEventListener('error', (ev) => {
    report(ev.error ?? new Error(ev.message), { source: ev.filename, line: ev.lineno });
  });
  window.addEventListener('unhandledrejection', (ev) => {
    const r = ev.reason;
    const err = r instanceof Error ? r : new Error(String(r));
    report(err, { source: 'promise' });
  });
}

export function report(err: Error, context?: Record<string, unknown>): void {
  if (bucket <= 0) return;
  bucket -= 1;
  const payload: ErrPayload = {
    message: err.message,
    stack: err.stack,
    url: location.href,
    ua: navigator.userAgent,
    ts: new Date().toISOString(),
    context,
  };
  try {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, blob);
    } else {
      void fetch(ENDPOINT, { method: 'POST', body: blob, keepalive: true });
    }
  } catch {
    // last-resort silence — reporting failure must never throw
  }
}
